import api from '@/services/api'
import { ShopClientDTO } from './interfaces/ShopClientDTO'
import { ITokenPayload } from './interfaces/AuthTokenDTO'
import { Role } from './enums/Roles.enum'

export default class SessionService {
  public data (token: string): ITokenPayload {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    const auth = JSON.parse(jsonPayload)
    return auth
  }

  public async softwareHouseData (token: string, cnpj: string): Promise<ShopClientDTO> {
    const softwareHouse = await api.get(`shop/clients/${cnpj}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return softwareHouse.data
  }

  public async getImageProfile (token: string, cnpj: string, userId: string): Promise<string> {
    const response = await api.get(`accounts/${cnpj}/image-profile/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return response.data?.image
  }

  public access (): boolean {
    if (localStorage.getItem('token')) {
      const base64Url = localStorage.getItem('token').split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      const auth = JSON.parse(jsonPayload)

      const accessRoles = [
        Role.PRINCIPAL,
        Role.COMERCIAL,
        Role.FINANCEIRO,
        Role.RESPONSAVEL_TECNICO,
        Role.ADMINISTRADOR
      ]

      return accessRoles.includes(auth.systems[0].type)
    }
  }

  public approvalAccess (): boolean {
    if (localStorage.getItem('token')) {
      const base64Url = localStorage.getItem('token').split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      const auth = JSON.parse(jsonPayload)

      return (auth.systems[0].type === Role.APROVACAO)
    }
  }

  public rootAccess (): boolean {
    if (localStorage.getItem('token')) {
      const base64Url = localStorage.getItem('token').split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      const auth = JSON.parse(jsonPayload)

      return (auth.systems[0].type === 'root')
    }
  }

  public adminAccess (): boolean {
    if (localStorage.getItem('token')) {
      const base64Url = localStorage.getItem('token').split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      const auth = JSON.parse(jsonPayload)

      return (auth.systems[0].type === Role.ADMINISTRADOR)
    }
  }

  public cnpj (): string {
    if (localStorage.getItem('token')) {
      const base64Url = localStorage.getItem('token').split('.')[1]
      if (!base64Url) {
        return
      }
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))

      const auth = JSON.parse(jsonPayload)
      const cnpj = auth.systems[0].cnpj
      return cnpj
    }
  }
}
